import React, { useMemo } from 'react';
import Select from 'react-select';
import { useField, useFormikContext } from 'formik';
import FieldWrapper from './FieldWrapper';

const FormikReactSelect = (props) => {
  const { name, label, fieldClassName, className, onChange, ...restProps } = props;
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  const flattenedOptions = useMemo(() => props.options?.flatMap((o) => {
    const isNotGrouped = 'value' in o;
    if (isNotGrouped) {
      return o;
    } else {
      return o.options;
    }
  }), [props.options]);

  const value = useMemo(
    () =>
      flattenedOptions?.filter((o) => {
        const isArrayValue = Array.isArray(field.value);

        if (isArrayValue) {
          const values = field.value;
          return values.includes(o.value);
        } else {
          return field.value === o.value;
        }
      }),
    [field.value, flattenedOptions]
  );

  const styles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? '#cbced1' : '#e2e5e8',
      borderRadius: 8,
    }),
    multiValue: (baseStyles) => ({
      ...baseStyles,
      color: '#63ad6f',
      backgroundColor: 'rgba(99, 173, 111, 0.1)',
    }),
    multiValueLabel: (baseStyles) => ({
      ...baseStyles,
      color: '#63ad6f',
      backgroundColor: 'rgba(99, 173, 111, 0.1)',
    }),
    multiValueRemove: (baseStyles) => ({
      ...baseStyles,
      color: '#63ad6f',
      backgroundColor: 'rgba(99, 173, 111, 0.1)',
      ':hover': {
        color: 'rgb(222, 53, 11)',
        backgroundColor: 'rgb(255, 189, 173)',
      },
    }),
  };

  return (
    <FieldWrapper
      name={name}
      label={label}
      fieldClassName={fieldClassName}
      className={className}
    >
      <Select
        {...restProps}
        styles={styles}
        value={value}
        classNamePrefix="select2-selection"
        onChange={(val) => {
          const _val = val;
          if (!_val) {
            setFieldValue(name, null);
            if (typeof onChange === 'function') {
              onChange(null);
            }
            return;
          }
          const isArray = Array.isArray(_val);
          if (isArray) {
            const values = _val.map((o) => o.value);
            setFieldValue(name, values);
          } else {
            setFieldValue(name, _val.value);
          }
          if (typeof onChange === 'function') {
            onChange(val);
          }
        }}
      />
    </FieldWrapper>
  );
};

export default FormikReactSelect;
